import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currencySelected: "CAD",
  exchangeRates: {},
};

const currencySlice = createSlice({
  name: "currency",
  initialState,
  reducers: {
    setCurrencySelected(state, action) {
      state.currencySelected = action.payload;
    },
    setExchangeRates(state, action) {
      state.exchangeRates = action.payload;
    },
  },
});

export const { setExchangeRates, setCurrencySelected } = currencySlice.actions;

export default currencySlice.reducer;
